import React, { Component } from 'react';
import './menu.css';
import user from './user.png';
import { Link } from 'react-router-dom';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import Modal_Empresa from '../Emp_Empresas/empresa_modal';
import history from '../../history';
import store from '../../store';

class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mostrar: 'noMostrar',
            tipo_usuario: '', // Admin, empresa, empleado, socio, perfil generado
            usuario: firebase.auth().currentUser,
            rutas: props.rutas,
            isReadyForInstall: false // Inicialmente false
        };

        this.handleClick = this.handleClick.bind(this);
        this.renderItemsMenu = this.renderItemsMenu.bind(this);
        this.renderMenuCompleto = this.renderMenuCompleto.bind(this);
        this.renderMenuEmpresa = this.renderMenuEmpresa.bind(this);
        this.renderMenuEmpleado = this.renderMenuEmpleado.bind(this);
        this.renderMenuSocios = this.renderMenuSocios.bind(this);
        this.selectMenu = this.selectMenu.bind(this);
        this.logout = this.logout.bind(this);
        this.downloadApp = this.downloadApp.bind(this);

        store.subscribe(() => {
            this.setState({
                mostrar: store.getState().mostrar
            });
        });
    }

    componentDidMount() {
        window.addEventListener("beforeinstallprompt", (event) => {
            // Prevent the mini-infobar from appearing on mobile.
            event.preventDefault();
            console.log("👍", "beforeinstallprompt", event);
            // Stash the event so it can be triggered later.
            window.deferredPrompt = event;
            // Enable the install button
            this.setState({ isReadyForInstall: true }, () => {
                console.log("isReadyForInstall set to true");
                this.forceUpdate(); // Force update to ensure the button is shown
            });
        });
    }

    async downloadApp() {
        console.log("👍", "butInstall-clicked");
        const promptEvent = window.deferredPrompt;
        if (!promptEvent) {
            // The deferred prompt isn't available.
            console.log("oops, no prompt event saved on window");
            return;
        }
        // Show the install prompt.
        promptEvent.prompt();
        // Log the result
        const result = await promptEvent.userChoice;
        console.log("👍", "userChoice", result);
        // Reset the deferred prompt variable, since
        // prompt() can only be called once.
        window.deferredPrompt = null;
        // Hide the install button.
        this.setState({ isReadyForInstall: false }, () => {
            console.log("isReadyForInstall set to false");
        });
    }

    handleClick() {
        Alert.closeAll();
        this.setState({
            mostrar: (this.state.mostrar === 'noMostrar' ? 'mostrar' : 'noMostrar')
        });
    }

    renderItemsMenu(x) {
        return <li key={x.url}><Link to={x.url}>{x.nombre}</Link></li>;
    }

    renderMenuCompleto() {
        return (
            <div>
                <li><Link to="/global">Manejo</Link></li>
                <li><Link to="/empresa">Empresa</Link></li>
                <li><Link to="/Asignar">Reservas</Link></li>
                <li><Link to="/tarifasAvianca">Tarifas Avianca</Link></li>
                <li><Link to="/Costos">Cancelaciones & Reasignaciones</Link></li>
                <li><Link to="/socios">Socios</Link></li>
                <li><Link to="/vehiculos">Vehiculos</Link></li>
                <li><Link to="/tipos_vehiculos">Tipos de Vehiculos</Link></li>
                <li><Link to="/empleados">Conductores</Link></li>
                <li><Link to="/bases">Bases</Link></li>
                <li><Link to="/tarifas">Tarifas</Link></li>
                <li><Link to="/tarifas_vehiculos">Tarifas por servicio</Link></li>
                <li><Link to="/usuarios">Usuarios</Link></li>
                <li><Link to="/perfiles">Perfiles</Link></li>
                <li><Link to="/invitados">Invitados</Link></li>
                <li><Link to="/calificaciones">Calificaciones</Link></li>
                <li><Link to="/tipos_calificaciones">Tipos Calificaciones</Link></li>
                <li><Link to="/informacion">Informacion</Link></li>
                <li><Link to="/reportes">Reportes</Link></li>
                <li><Link to="/reporte_viajes_empresa">Reporte Viajes Empresa</Link></li>
                <li><Link to="/reporte_operacional">Reporte Operacional</Link></li>
                <li><Link to="/reporte_asig_viaje">Reporte Corporativo</Link></li>
            </div>
        );
    }

    renderMenuEmpleado() {
        return (
            <div>
                <li><Link to="/">Reportarse en base</Link></li>
                <li><Link to="/bitacoraEmpleado">Bitácora diaria</Link></li>
                <li>
                    {this.state.isReadyForInstall && (
                        <button
                            onClick={this.downloadApp}
                            style={{
                                background: 'none',
                                border: 'none',
                                padding: '0',
                                font: 'inherit',
                                color: '#DDDDDD',
                                cursor: 'pointer'
                            }}
                        >
                            Descargar App
                        </button>
                    )}
                </li>
                <li><Link to="#" onClick={this.logout}>Cerrar Sesión</Link></li>
            </div>
        );
    }

    renderMenuEmpresa() {
        let uid = firebase.auth().currentUser !== null ? firebase.auth().currentUser.uid : '';
        return (
            <div>
                <li><Link to="/nuevoViaje">Programacion</Link></li>
                <li><Link to="/planiViajes">Planificacion</Link></li>
                <li><Link to="/reservaE">Reservas</Link></li>
                <li><Link to="/costos">Centro de costos</Link></li>
                <li><Link to="/empleados">Empleados</Link></li>
                <li><Link to="/viajes_empleados">Viajes realizados</Link></li>
                <li><Link to="/reporte_operacional">Reporte Operacional</Link></li>
                <Modal_Empresa nodo={uid} onClick={this.handleClick} />
                <li><Link to="#" onClick={this.logout}>Cerrar Sesión</Link></li>
            </div>
        );
    }

    renderMenuSocios() {
        return (
            <div>
                <li><Link to="/reporte_viajes_conductores">Viajes por conductor</Link></li>
                <li><Link to="/reporte_conductores">Conductores</Link></li>
                <li><Link to="/reporte_vehiculos">Vehiculos</Link></li>
                <li><Link to="#" onClick={this.logout}>Cerrar Sesión</Link></li>
            </div>
        );
    }

    selectMenu() {
        if (this.state.rutas === 'admin') {
            return this.renderMenuCompleto();
        } else if (this.state.rutas === 'empresa') {
            return this.renderMenuEmpresa();
        } else if (this.state.rutas === 'empleado') {
            return this.renderMenuEmpleado();
        } else if (this.state.rutas === 'socios') {
            return this.renderMenuSocios();
        } else {
            return this.state.rutas.map(this.renderItemsMenu);
        }
    }

    logout() {
        history.push("/");
        firebase.auth().signOut().then(function () {
        }).catch(function (error) {
        });
    }

    render() {
        return (
            <div>
                <div id="mostrar-nav" onClick={this.handleClick}></div>
                <nav className={this.state.mostrar} onClick={this.handleClick}>
                    <div className="user-area">
                        <img src={user} className='profile-img' width="60px" />
                        <p className="userName" style={{ marginTop: '1%', }}>{this.props.usuario}</p>
                    </div>
                    <div className="separador"></div>
                    <ul className="menu">
                        {this.selectMenu()}
                    </ul>
                </nav>
            </div>
        );
    }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.jsx